import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { BUILDINGS_ROUTES } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppInitializerService } from './services/app-initializer.service';
import { HttpClientInterceptor } from './modules/buildings-shared/utilities/http-client.interceptor';
import { HttpAuthInterceptor } from './modules/buildings-shared/utilities/http-auth.interceptor';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => {
            const appInitializer = inject(AppInitializerService);
            return appInitializer.start();
        }),
        provideRouter(BUILDINGS_ROUTES),
        provideMarkdown(),
        // CookieService,
        // BuildingsCookieService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
        // { provide: APP_INITIALIZER, multi: true, deps: [AppInitializerService], useFactory: (appInitializerService: AppInitializerService) => () => appInitializerService.start() },
    ]
};
